export default "https://cdn-static.gokick.com/assets/1c04a0e7cb9e690604c984af7e1d0f36647cf8e0/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";